import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {FUIAbstractLabel} from "../../../labels/abstract-label";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-pop-checkbox-label",
    styleUrls: ["./pop-checkbox-label.component.scss"],
    templateUrl: "./pop-checkbox-label.component.html"
})
export class FUIPopCheckboxLabelComponent extends FUIAbstractLabel {
    @Input() allowMarkup: boolean = false;
}
